import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@commons/controls/select/select.module';
import { FooterModule } from '@commons/footer/footer.module';
import { HeaderModule } from '@commons/header/header.module';
import { HtmlParserModule } from '@commons/html-parser/html-parser.module';
import { LinkModule } from '@commons/link/link.module';
import { MutationObserverModule } from '@commons/mutation-observer/mutation-observer.directive';
import { PipeModule } from '@commons/pipe/pipe.module';
import { RouterFragmentModule } from '@commons/router-fragment/router-fragment.module';
import { ScrollSpyModule } from '@commons/scroll-spy/scroll-spy.module';
import { SearchEngineModule } from '@commons/search-engine/search-engine.module';
import { SocialIconsModule } from '@commons/social-icons/social-icons.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TabBarModule } from '@commons/tab-bar/tab-bar.module';
import { CompanyModule as CompanyDomainModule } from '@domains/company/company.module';
import { JobModule } from '@domains/job/job.module';
import { WizFileModule } from '@domains/wiz-file/wiz-file.module';
import { CustomComponent } from '@features/companies/view/tabs/custom/custom.component';
import { JobsComponent } from '@features/companies/view/tabs/jobs/jobs.component';
import { NewsComponent } from '@features/companies/view/tabs/news/news.component';
import { OtherInfoComponent } from '@features/companies/view/tabs/other-info/other-info.component';
import { PartnersJobsComponent } from '@features/companies/view/tabs/partners-jobs/partners-jobs.component';
import { PresentationComponent } from '@features/companies/view/tabs/presentation/presentation.component';
import { ViewComponent } from '@features/companies/view/view.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CompanyRoutingModule } from '@routing/company/company-routing.module';
import { CompanyStoreModule } from '@store/company/company.store.module';
import { NewsStoreModule } from '@store/news/news.store.module';
import { SearchCompaniesStoreModule } from '@store/search/companies/search-companies.store.module';
import { HeadDescriptionModule, HeadTitleModule } from '@wizbii/seo-lib';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    CompanyRoutingModule,
    CompanyDomainModule,
    HeaderModule,
    NgSelectModule,
    SearchEngineModule,
    LinkModule,
    ScrollSpyModule,
    SvgIconModule,
    TabBarModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    SelectModule,
    WizFileModule,
    SearchCompaniesStoreModule,
    CompanyStoreModule,
    NewsStoreModule,
    PipeModule,
    JobModule,
    RouterFragmentModule,
    HtmlParserModule,
    FooterModule,
    SocialIconsModule,
    HeadTitleModule,
    HeadDescriptionModule,
    MutationObserverModule,
  ],
  declarations: [
    ViewComponent,
    JobsComponent,
    PartnersJobsComponent,
    PresentationComponent,
    NewsComponent,
    CustomComponent,
    OtherInfoComponent,
  ],
})
export class CompanyModule {}
